<template>

  <div class="logo-div">
    <!-- <img src="/assets/images/Logos/topotradeLogo1.webp" class="logo-image" /> -->
    <img :src="$store.getters.images.logo" alt="" class="logo-image">
  </div>

  <div class="subtitle">
    {{$translation($websiteText().sign_up_login_popup_login_first_line)}}<br />
    {{$translation($websiteText().sign_up_login_popup_login_second_line)}}
  </div>

  <button
    @click="() => loginWithGoogle()"
    class="nobutton"
    style="display: flex; margin: 20px auto"
  >
    <div class="rectangle">
      <img src="/assets/images/GoogleLogo.png" />
      <div class="google">{{ $translation($websiteText().sign_up_login_popup_continue_with_google) }}</div>
    </div>
  </button>
  <hr class="mt-2 mb-2" />
  <div v-if="responseAuthError.message" class="mt-3 error-message">
    <t-inline-message :message="responseAuthError.message" severity="error" />
  </div>

  <div class="form">
    <t-form :onSubmit="login" :schema="schema">

      <div playwright-id='email'>
        <t-input-text
          v-model="credentials.email"
          name="email"
          :placeholder="$translation($websiteText().my_profile_email)"
          :onInputText="onInput"
          :style="'height: 42px'"
        />
      </div>

      <div playwright-id='password'>
        <t-input-text
          type="password"
          :style="'height: 42px'"
          v-model="credentials.password"
          name="password"
          :placeholder="$translation($websiteText().website_generals_password)"
          :onInputText="onInput"
        />
      </div>

      <div class="remember-me">
        <t-checkbox
          name="rememberMe"
          v-model="credentials.rememberMe"
          :label="$translation($websiteText().sign_up_login_popup_remember_me)"
        />
      </div>

      <div class="submit-btn-container" playwright-id='submit'>
        <t-button
          type="submit"
          :label="$translation($websiteText().sign_up_login_popup_login_button)"
          color="primary-color"
          :onClick="() => loginValidate()"
          buttonClass="signin-btn-class"
        />
      </div>

      <hr class="mt-2 mb-2" />

      <div class="footer-line">
        <t-button
          style="margin-top:6px; height:22px;"
          type="button"
          :label="$translation($websiteText().sign_up_login_popup_forgot_password)"
          buttonClass="nobutton"
          @click="() => goToResetComponent()"
        />
        <div  class="footer-line2">
          <!-- <div class="account">{{$translation($websiteText().sign_up_login_popup_no_account)}}</div> -->
          <button
            class="nobutton"
            style="padding: 0px;"
            @click="() => goToRegisterComponent()"
          >
            <div class="signup-btn">{{$translation($websiteText().sign_up_login_popup_signup_here_button)}}</div>
          </button>
        </div>
      </div>
    </t-form>
  </div>
</template>
<script>
import { reactive } from "@vue/reactivity";
import TButton from "../../../common/components/buttons/TButton.vue";
import TInputText from "../../../common/components/input-text/TInputText.vue";
import TForm from "../../../common/components/TForm.vue";
import TCheckbox from "../../../common/components/controls/TCheckbox.vue";

import * as Yup from "yup";

import store from "../../../store";
import { useStore } from "vuex";

import {
  AUTH_REQUEST,
  AUTH_LOGOUT,
  GOOGLE_AUTH_REQUEST,
  REPLACE_AUTH_ACTIVE_COMPONENT,
} from "../store/actions";
import TInlineMessage from "../../../common/components/messages/TInlineMessage.vue";
// import { useI18n } from "vue-i18n";
import ForgetPassword from "./ForgetPassword.vue";
import GeneralVariables from "../../../common/utils/GeneralVariables";
import GeneralHelper from "../../../common/helpers/GeneralHelper";
import { SHOW_TOAST_MESSAGE } from "../../../common/store/actions";
import Register from "./Register.vue";
import CartService from "../../../common/services/checkout/CartService";

export default {
  name:"Signin",
  components: {
    TButton,
    TInputText,
    TForm,
    TCheckbox,
    TInlineMessage,
  },

  setup() {
    const store = useStore()
    let responseAuthError = reactive({
      message: "",
    });

    const credentials = reactive({
      email: localStorage.getItem("email") ?? "",
      password: localStorage.getItem("password") ?? "",
      rememberMe: localStorage.getItem("email") ? true : false,
    });

    const onInput = () => {
      responseAuthError.message = "";
    };

    // const i18n = useI18n();

    const schema = Yup.object().shape({
      email: Yup.string().required().email(),
      password: Yup.string().required().min(6),
    });

    const loginValidate = () => {
      schema
        .validate(credentials, { abortEarly: false })
        .then()
        .catch((e) => {
          for (let i = 0; i < e.errors.length; i++) {
            store.dispatch(
              SHOW_TOAST_MESSAGE,
              GeneralHelper.buildMessage(3, e.errors[i])
            );
          }
        });
    };

    async function updateCart(){
     let  cart = []
      store.getters.cartItems.forEach(function(item) {
                cart.push(item.kit);
            });

         
      let cartService = new CartService();
      await cartService.UpdateCart(cart)
    };

    const login = () => {
      store
        .dispatch(AUTH_REQUEST, credentials)
        .then(() => {
          updateCart()
        })
        .catch((e) => {
          if (e.response && e.response.data) {
            store.dispatch(
              SHOW_TOAST_MESSAGE,
              GeneralHelper.buildMessage(3, e.response.data.message)
            );
            responseAuthError.message = e.response.data.message;
          }
        });
    };

    const closePath = window.location.origin + "/en/close";

    const loginWithGoogle = () => {
      window.open(
        GeneralVariables.BACKEND1 +
          GeneralVariables.KEYCLOAK_REALM_AND_CLIENT_SUBDIRECTORY +
          "&redirect_uri=" +
          closePath +
          "&state=STATE&response_type=code&scope=" +
          (true ? "offline_access" : "openid") +
          "&nonce=NONCE&kc_idp_hint=google",
        "myWindow",
        "width=600,height=600"
      );
    };

    window.HandleGoogleLoginPopup = (result) => {
      return new Promise((resolve, reject) => {
        if (result.code == undefined || result.code == "") {
          responseAuthError.message = "Authentication failed";
          reject();
        } else {
          store
            .dispatch(GOOGLE_AUTH_REQUEST, {
              code: result.code,
              redirect_uri: closePath,
              rememberMe: credentials.rememberMe,
            })
            .then(() => {
              resolve();
              updateCart()
            })
            .catch((e) => {
              if (e.response && e.response.data)
                responseAuthError.message = e.response.data.message;
              reject();
            });
        }
      });
    };

    const goToResetComponent = () => {
      store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, ForgetPassword);
    };

    const goToRegisterComponent = () => {
      store.dispatch(REPLACE_AUTH_ACTIVE_COMPONENT, Register);
    };

    const logout = () => {
      store.dispatch(AUTH_LOGOUT, credentials).then(() => {});
    };

    return {
      schema,
      login,
      loginWithGoogle,
      logout,
      credentials,
      responseAuthError,
      onInput,
      store,
      goToResetComponent,
      loginValidate,
      goToRegisterComponent,
    };
  },
};
</script>
<style lang="scss" scoped>

  @import '../style/auth.scss';
</style>